import api from "../../../api";

export class ComunicacaoUsuarioViewModel {

    static async confirmaToken(token: string) {
        try {
            const response = await api.post(`/emails/confirmacao?token=${token}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
